module.exports = __webpack_public_path__ + "img/card-img_1(375).3e1e92cb.png";